import { render, staticRenderFns } from "./SplitOrder.vue?vue&type=template&id=480271fe&scoped=true&"
import script from "./SplitOrder.vue?vue&type=script&lang=js&"
export * from "./SplitOrder.vue?vue&type=script&lang=js&"
import style0 from "./SplitOrder.vue?vue&type=style&index=0&id=480271fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480271fe",
  null
  
)

export default component.exports